export default {
  data() {
    return {
      width: 0,
      height: 0,
    };
  },
  mounted() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  },
  destroyed() {
    window.removeEventListener("resize", this.resize.bind(this));
  },
  methods: {
    resize() {
      if (!this.$el) {
        return;
      }
      const width = this.$el.offsetWidth;
      const height = this.$el.offsetHeight;
      this.width = width;
      this.height = height;
    },
  },
};
